import { Form, Row } from "react-bootstrap";
import styled from "styled-components";

const AppStyledForm = styled(Form)`
  & .form-control {
    font-size: inherit;
  }
  & .form-label {
    width: 100%;
  }
  & .form-check-label {
    padding-left: 10px;
  }
`;

const StyledRow = styled(Row)`
  padding-bottom: 20px;
`;

export { AppStyledForm, StyledRow };
